import React from "react";
import get from "lodash/get";
import noop from "lodash/noop";
import Select, {components} from "react-select";
import {useTranslation} from "react-i18next";
import Label from "@unibuddy/machop/General/components/Label/Label";
import useAnalytics from "@unibuddy/machop/AnalyticsNew/hooks/useAnalytics";
import s from "./BuddiesFilterSection.pcss";
import {customStyles} from "../../../../shared/styles/filterCustomStyles";

export const FilterSelection = ({filters = {}, customAttributesFilters = [], onChange = noop}) => {
    return Object.keys(filters).map(filterkey => {
        const customAttribute =
            customAttributesFilters && customAttributesFilters.find(a => a.id === filterkey);
        if (customAttribute) {
            const option = customAttribute.options.find(o => o.id === filters[filterkey]);
            if (option) {
                return (
                    <Label
                        key={filterkey}
                        text={option.value}
                        onRemove={() =>
                            onChange({
                                target: {name: filterkey, value: undefined},
                            })
                        }
                    />
                );
            }
        }
        return filters[filterkey] ? (
            <Label
                key={filterkey}
                text={filters[filterkey]}
                onRemove={() => onChange({target: {name: filterkey, value: undefined}})}
            />
        ) : null;
    });
};

const Option = components.Option;

const StaffFilters = ({filters, setFilters, buddiesFilterOptionsData}) => {
    const {
        events: {buddiesFiltered},
    } = useAnalytics();
    const {t} = useTranslation("mentorCard");
    const onChange = e => {
        setFilters({...filters, [e.target.name]: e.target.value});
        if (e.target.name && e.target.value) {
            buddiesFiltered({
                filterKey: e.target.name,
                filterValue: e.target.value,
                buddyType: "staff",
            });
        }
    };

    const roles = get(buddiesFilterOptionsData, "buddiesFilterOptions.roles", []);
    const departments = get(buddiesFilterOptionsData, "buddiesFilterOptions.departments", []);
    const customAttributesFilters = get(
        buddiesFilterOptionsData,
        "buddiesFilterOptions.customAttributesFilters",
        [],
    );
    return (
        <div className={s.filtersWrapper}>
            <div className={s.filters}>
                {roles ? (
                    <Select
                        id="role-autocomplete"
                        placeholder={t("role", "Role")}
                        name="role"
                        aria-label="Roles"
                        styles={customStyles}
                        options={roles.map(x => ({label: x, value: x}))}
                        onChange={e => onChange({target: {name: "role", value: e.value}})}
                        noOptionsMessage={() => t("noOptionsMessage", "No options")}
                    />
                ) : null}
                {departments ? (
                    <Select
                        noOptionsMessage={() => t("noOptionsMessage", "No options")}
                        id="department-autocomplete"
                        placeholder={t("department", "Department")}
                        styles={customStyles}
                        name="department"
                        aria-label="Departments"
                        options={departments.map(x => ({label: x, value: x}))}
                        onChange={e => onChange({target: {name: "department", value: e.value}})}
                        components={{
                            Option: optionProps => (
                                <Option
                                    {...optionProps}
                                    // adding classname for testing, since Option comp takes only few and ignores any custom prop
                                    className={`${
                                        optionProps.className
                                    } e2e-test-mentor-filter-Departments-option`}
                                />
                            ),
                        }}
                    />
                ) : null}
                {customAttributesFilters
                    ? customAttributesFilters.map(attribute => (
                          <Select
                              noOptionsMessage={() => t("noOptionsMessage", "No options")}
                              key={`${attribute.id}-autocomplete`}
                              id={`${attribute.name}-autocomplete`}
                              placeholder={attribute.name}
                              name={attribute.id}
                              aria-label={attribute.name}
                              options={attribute.options.map(x => ({
                                  label: x.value,
                                  value: x.id,
                              }))}
                              styles={customStyles}
                              onChange={e =>
                                  onChange({
                                      target: {name: attribute.id, value: e.value},
                                  })
                              }
                          />
                      ))
                    : null}
            </div>
            <div className={s.reset}>
                <FilterSelection
                    filters={filters}
                    customAttributesFilters={customAttributesFilters}
                    onChange={onChange}
                />
            </div>
        </div>
    );
};

const BuddiesFilterSection = ({buddyGroupType, ...rest}) => {
    if (buddyGroupType === "staff") {
        return <StaffFilters {...rest} />;
    }
    return null;
};

export default BuddiesFilterSection;
